import {
    UPDATE_ACDEMIC_YEAR,
    UPDATE_CURRENT_ROUTE_MENU,
    UPDATE_ROLE_ACTION_SCOPE,
    UPDATE_ROLE_DATA_SCOPE,
    UPDATE_SELECTED_ACADEMIC_YEAR,
    UPDATE_SELECTED_SEMESTER,
    UPDATE_SEMESTER,
} from '../actionTypes'

const getAuthenState = () => ({
    accesstoken: localStorage.getItem('accesstoken'),
    renewtoken: localStorage.getItem('renewtoken'),
    user: JSON.parse(localStorage.getItem('user'))?.user,
    selectedSemester: JSON.parse(localStorage.getItem('user'))?.user?.semester,
    selectedAcademicYear: JSON.parse(localStorage.getItem('user'))?.user?.academicYear,
})

// const updateNotifications = (notifications) => ({ notifications })

const updateUser = user => {
    localStorage.setItem('user', JSON.stringify(user))
    return user
}

const updateSelectedSemester = semester => ({semester})
const updateSelectedAcademicYear = academicYear => ({academicYear})

export default function (state = getAuthenState(), action) {

    let tmpState = JSON.parse(JSON.stringify(state))

    // Login
    if (action.type === 'AUTH_LOGIN') {
        return updateUser(action.payload)
    }

    // Renew
    if (action.type === 'AUTH_RENEW') {
        // return getAuthenState();
        return state
    }


    // Logout
    if (action.type === 'AUTH_LOGOUT') {
        localStorage.removeItem('accesstoken')
        localStorage.removeItem('renewtoken')
        localStorage.removeItem('user')
        localStorage.removeItem('routeList')
        return {}
    }

    if (action.type === 'UPDATE_STUDENT') {
        state.user.student = action.payload
        return updateUser(state)
    }

    if (action.type === 'UPDATE_TEACHER') {
        state.user.teacher = action.payload
        return updateUser(state)
    }

    if (action.type === 'SET_SKIP_ALERT_FINE') {
        state.user.student.finStd = action.payload
        return updateUser(state)
    }

    if (action.type === 'UPDATE_ROLE') {
        state.user.role = action.payload
        return updateUser(state)
    }

    if (action.type === 'UPDATE_ROLE_MENUS') {
        state.user.roleMenus = action.payload
        return updateUser(state)
    }

    if (action.type === UPDATE_SELECTED_SEMESTER) {
        // return updateSelectedSemester(action.payload);
        console.log('UPDATE_SELECTED_SEMESTER', action.payload)
        state.selectedSemester = Number.isNaN(action.payload) ? state.user?.semester : action.payload
        return updateUser(state)
    }

    if (action.type === UPDATE_SELECTED_ACADEMIC_YEAR) {
        // return updateSelectedAcademicYear(action.payload);
        console.log('UPDATE_SELECTED_ACADEMIC_YEAR', action.payload)
        state.selectedAcademicYear = Number.isNaN(action.payload) ? state.user?.academicYear : action.payload
        return updateUser(state)
    }

    if (action.type === UPDATE_ROLE_ACTION_SCOPE) {
        state.user.permission.action_scope = action.payload
        return updateUser(state)
    }

    if (action.type === UPDATE_CURRENT_ROUTE_MENU) {
        state.user.permission.current_route_menu = action.payload
        return updateUser(state)
    }

    if (action.type === UPDATE_SEMESTER) {
        state.user.semester = action.payload
        return updateUser(state)
    }

    //acdemicYear
    if (action.type === UPDATE_ACDEMIC_YEAR) {
        state.user.academicYear = action.payload
        return updateUser(state)
    }

    return state
}
